module.exports = __webpack_public_path__ + "media/images/Lock_Shadow_Gold_Unlocked_38-a0cddcd34c50e02074477f6a761175f7.png";